module.exports = __webpack_public_path__ + "img/factura.9c787f26.jpg";